var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EstateAssistContainer',{attrs:{"testator":_vm.testator,"quotes":_vm.quotes,"startLeadBody":_vm.startLeadBody,"peopleRelations":_vm.peopleRelations,"buttonLoading":_vm.buttonLoading},on:{"updateInsuranceAndRequestQuotes":_vm.updateInsuranceAndRequestQuotes,"updateInsurance":_vm.updateInsurance,"startLead":_vm.startLead}})
}
var staticRenderFns = []

export { render, staticRenderFns }